/**
 * @file professionExamples.js
 * @description The worked examples for the profession-description field.
 *
 * MOVED here out of `pages/Profile.js` so the three surfaces that now ask the
 * same question read from ONE source: the personal area, the welcome dialog and
 * the dashboard's inline `no-profession` empty state. Two copies of an example
 * drift, and an example that contradicts the one the user saw a screen earlier
 * is worse than no example at all.
 *
 * TWO SHAPES, and the split is deliberate:
 *
 *   PROFESSION_EXAMPLES       - the PAIR. Long, two-bullet, with a blank-line
 *                               structure. It is the personal area's
 *                               wide-screen placeholder and the contents of its
 *                               narrow-screen "examples" panel. Both examples
 *                               are kept because two varied ones help users
 *                               write better than a single template does: the
 *                               first is service-led, the second names what the
 *                               CLIENT is asking for before listing services,
 *                               which is the pattern that actually matches well.
 *
 *   PROFESSION_EXAMPLE_SHORT  - ONE sentence, owner-approved 2026-09-19 for the
 *                               modal surfaces. On a phone the pair ran to about
 *                               nine lines and buried the field it was
 *                               explaining. The dashboard's ProfessionField
 *                               carries it; the welcome studio has its own
 *                               example (studio/welcomeCopy.js WELCOME_EXAMPLE).
 *
 * Neither string is new copy: the pair is today's live text, the short one is
 * approved. Nothing here may be reworded without owner approval.
 */

/** The two worked examples - the personal area's placeholder/panel. */
export const PROFESSION_EXAMPLES = {
  he: 'לדוגמה:\n• אני עורך דין מקרקעין. אני עוזר לאנשים שקונים או מוכרים דירה, מתמודדים עם תמ"א 38 או פינוי-בינוי, חותמים על הסכמי רכישה ושכירות, ומול מחלוקות שכנים ותביעות נדל"ן.\nאו\n• אני יועץ שיווק דיגיטלי. אני עוזר לעסקים קטנים ובינוניים שרוצים יותר לקוחות ופונים אליי כדי להביא לידים - קידום ממומן בגוגל ובפייסבוק, ניהול רשתות חברתיות, SEO ובניית אסטרטגיית שיווק.',
  en: "e.g.,\n• I'm a real estate lawyer. I help people buying or selling an apartment, dealing with Tama 38 or urban renewal, signing purchase and rental agreements, and with neighbor disputes and real estate claims.\nor\n• I'm a digital marketing consultant. I help small and medium businesses that want more customers and come to me to bring in leads - Google and Facebook ads, social media management, SEO, and marketing strategy.",
};

/**
 * The single short example - the placeholder on the modal + inline surfaces.
 * Owner-approved (Hebrew and English) 2026-09-19.
 */
export const PROFESSION_EXAMPLE_SHORT = {
  he: 'לדוגמה: אני עורך דין מקרקעין - מלווה אנשים שקונים או מוכרים דירה, תמ"א 38 והסכמי שכירות.',
  en: "e.g., I'm a real estate lawyer - I help people buying or selling an apartment, Tama 38, and rental agreements.",
};

/** The matcher's own bounds (`schemas/profession_matching.py`), mirrored here. */
export const PROFESSION_MIN_LENGTH = 10;
export const PROFESSION_MAX_LENGTH = 500;
